module.exports = __webpack_public_path__ + "img/2021_10_dande_kochijo_a4_fin_web.63d6ca37.jpg";